import Axios from 'axios';

export default Axios.create({
  // baseURL: process.env.REACT_APP_API_BASE_URL,
  // withCredentials: true,

  // baseURL: 'http://localhost:8080/api',
  // baseURL: 'http://192.168.15.20:8080/admin/api', // artsilk conexao observar ip
  baseURL: 'https://eloadmin.com.br:8443/admin/api',
  withCredentiais: true,
});
